import { fromSpecific } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'
import { toArr } from '@rehaje/shared'

import { ValuableNode } from '../../models'

import type {
  SchemaUnionSpecific,
  TypedNode,
  TypedSpecific
} from '@rehaje/core'
import type { MustacheNode } from '@rehaje/lowcode'

/**
 * @example
 * {
 *   type:"Schema.Union",
 *   target:{
 *      type:"Mustache",
 *      code:"t1"
 *   },
 *   types:[
 *     {
 *       type:"Schema.String",
 *       id:"t1"
 *     },
 *     {
 *       type:"Schema.String",
 *       id:"t2"
 *     }
 *   ]
 * }
 */

export class SchemaUnionNode extends ValuableNode {
  @reactive()
  current?: TypedNode

  @fromSpecific()
  @reactive()
  target?: MustacheNode | string

  @reactive('shallow')
  types?: TypedSpecific | TypedSpecific[] = []

  constructor(specific: SchemaUnionSpecific) {
    super(specific)
    this.types = specific.types
  }

  override getIterableKeys(): PropertyKey[] {
    return super.getIterableKeys().concat(['types'])
  }

  getTargetSchema(id?: string): TypedSpecific | undefined {
    if (!id) return
    const target = toArr(this.types).find((item) => item.id === id)
    return {
      ...target,
      id
    } as TypedSpecific
  }
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Union': SchemaUnionNode
  }
}
